import styled from "styled-components";

export const HeroContainer = styled.aside`
  background-color: #7689de;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 80px);
  position: relative;
  z-index: 1;
`;

export const HeroBg = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const ImageBg = styled.img`
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  opacity: 0;
`;

export const HeroContent = styled.div`
  z-index: 3;
  max-width: 1100px;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const HeroH1 = styled.div`
  color: #ffb400;
  font-size: 55px;
  font-weight: bold;
  text-align: center;
  padding: 0 40px;

  @media screen and (max-width: 768px) {
    font-size: 52px;
  }
  @media screen and (max-width: 480px) {
    font-size: 42px;
  }
`;


export const HeroP = styled.p`
  color: #f5f5f5;
  font-size: 30px;
  text-align: center;
  margin-top: 20px;
  padding: 0 40px;

  @media screen and (max-width: 768px) {
    font-size: 27px;
  }
  @media screen and (max-width: 480px) {
    font-size: 24px;
  }
`;

export const HeroBtnWrapper = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;

  @media screen and (max-width: 480px) {
    flex-direction: column;
  }
`;

export const HeroBtn = styled.button`
  cursor: pointer;
  background-color: transparent;
  border: none;
  white-space: nowrap;
`;

export const HeroImgPlaystore = styled.img`
  display: flex;
  align-items: center;
  width: 250px;

  -o-object-fit: fill;
  object-fit: fill;
`;

export const HeroImgAppstore = styled.img`
  display: flex;
  align-items: center;
  width: 197px;

  -o-object-fit: fill;
  object-fit: fill;
`;
